import type { PitchFeature } from "@/types/camping";

export interface PitchFeatureSelectProps {
  features: PitchFeature[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
  emptyHint?: string;
}

/** Checkbox-Liste zur Auswahl von Platz-Eigenschaften. */
export function PitchFeatureSelect({
  features,
  selectedIds,
  onChange,
  disabled = false,
  emptyHint,
}: PitchFeatureSelectProps) {
  const selectable = features.filter((f) => f.is_active || selectedIds.includes(f.id));
  if (selectable.length === 0) {
    return emptyHint ? <p className="text-xs text-label-tertiary">{emptyHint}</p> : null;
  }

  function toggle(id: string, checked: boolean) {
    if (checked) {
      onChange([...selectedIds, id]);
    } else {
      onChange(selectedIds.filter((v) => v !== id));
    }
  }

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm text-label">
      {selectable.map((feature) => (
        <label key={feature.id} className="flex items-center gap-2">
          <input
            type="checkbox"
            className="rounded border-separator text-accent focus:ring-accent"
            checked={selectedIds.includes(feature.id)}
            onChange={(e) => toggle(feature.id, e.target.checked)}
            disabled={disabled}
          />
          {feature.name}
          {feature.show_in_online_booking ? (
            <span
              className="rounded bg-fill-tertiary px-1 text-[10px] uppercase tracking-wide text-label-tertiary"
              title="In der Online-Buchung sichtbar"
            >
              Online
            </span>
          ) : null}
        </label>
      ))}
    </div>
  );
}
